import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { categoriaReceitaAdapter } from "@/data";
import { toast } from "@/hooks/use-toast";
import type { CategoriaReceita } from "@/types/tabelas-auxiliares";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: CategoriaReceita | null;
  onSuccess: () => void;
}

export function CategoriaReceitaDeleteDialog({ open, onOpenChange, item, onSuccess }: Props) {
  const handleConfirm = async () => {
    if (!item) return;
    try {
      await categoriaReceitaAdapter.delete(item.id_categoria_receita);
      toast({ title: "Sucesso", description: "Categoria excluída com sucesso!" });
      onSuccess();
      onOpenChange(false);
    } catch (error) {
      toast({ title: "Erro", description: "Não foi possível excluir.", variant: "destructive" });
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir Categoria de Receita</AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja excluir permanentemente a categoria "{item?.nome}"?
            Esta ação não pode ser desfeita.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm}>Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
